<template>
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center"> <b>Des Matricular Estudiantes</b> </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p class="text-primary text-center"> <b>Nombre: </b> {{parseModulo()}} </p>
          <form action="#" class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-2"> Asunto: </label>
              <div class="col-sm-8"> <input type="email" class="form-control input-sm" v-model="asunto"> </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2"> Correo: </label>
              <div class="col-sm-8"> <input type="email" class="form-control input-sm" v-model="correo"> </div>
            </div>
          </form>

          <small class="text-info">Seleccione los estudiantes para desmatricular en Moodle:</small>
          <p class="text-primary" style="margin-top:0"> <small>{{msg}}</small> </p>

          <div class="table-responsive">
            <button class="btn btn-link btn-sm" @click="selcheck(true)"> <span class="glyphicon glyphicon-check"></span> Todos</button>
            <button class="btn btn-link btn-sm" @click="selcheck(false)"> <span class="glyphicon glyphicon-unchecked"></span> Ninguno</button>
            <input type="text" placeholder="Buscar..." v-model="filter">
            <table class="table table-striped table-condensed table-hover" id="midatatabledel">
              <thead>
                <tr>
                  <th> <small>Nro</small> </th>
                  <th style="min-width:350px!important"> <small>Estudiante</small> </th>
                  <th> <small>Moodle</small> </th>
                  <th> <small>Estado</small> </th>
                  <th> <small>Acciones</small> </th>
                </tr>
              </thead>
              <tbody>
                <tr :key="ind" v-for="(e,ind) in datos">
                  <td> <small> {{ind+1}} </small> </td>
                  <!-- <td> <small> <input type="checkbox" v-model="e.check"> {{e.nombre}} </small> </td> -->
                  <td> <small> {{e.nombre}} </small> </td>
                  <td> <small> {{e.umoodle}} </small> </td>
                  <td> 
                    <div v-if="e.estado=='2'" class="loader"></div> 
                    <small v-else> {{e.estado}} </small>
                  </td>
                  <td>
                    <button class="btn btn-link btn-sm" @click="delUnito(e)" title="Des Matricular"> <span class="glyphicon glyphicon-remove-sign"></span> </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        
        <Alertas 
          ref="ealertar" 
          v-bind:msgSuccess="'El cambio de estado se realizo satisfactoriamente.'"
          v-bind:msgLoading="'Aplicando...'"
        />
        <div class="modal-footer">
          <!-- <button @click="submit" v-if="activo" type="button" class="btn btn-azul">Aceptar</button> -->
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Alertas from '@/components/AAlertas.vue'

export default {
  props:{ modulo:{type:Object,required:true},xprograma:{type:Object,required:true} },// {pid,ccid,tag}
  data(){
    return{
      asunto:'Inscripcion Moodle',
      correo:'',
      timeoutHnd: 0,
      filter: null,
      activo:true,
      isLoading: false,
      estudiantes:[],
      categoria:{},
      datos:[],
      msg:'',
    }
  },
  components:{ Alertas },
  watch:{ 'filter':function(){ this.myFunction1(this.filter) } },
  methods:{
    parseLabel( opt ){ return opt.nombre },
    parseModulo(){
      if( this.modulo.tag ) return this.modulo.tag.modulo.nombre
      else "";
    },
    delUnito( e ){
      e.estado = 2;
      this.desmatricular( e )
    },
    submit(){
      var vue = this;
      this.datos.forEach(function(e){
        if( e.check ) {
          e.estado = 2;
          vue.desmatricular( e )
        }
      })
    },
    selcheck( estado ){
      this.datos.forEach(function(e){
        e.check = estado;
      })
    },
    desmatricular( estudiante ){
      var vue = this;
      var opt = {
        verification: 'anular',
        verificationHelp: 'Escriba "[+:verification]" para desmatricular.',
        okText:"Anular certificado",
        cancelText:"cancelar",
        backdropClose:false,
        animation: 'bounce',
        loader: true, 
        type:"hard"
      }
      var message = {
        title: 'Confirmar desmatriculacion',
        body: '<br> <b>NOTA:</b> Al desmatricular un estudiante se perderean todos su datos.'
      };
      this.$dialog.confirm(message,opt)
      .then(function( dialog ) { 
        vue.desmatricular2( estudiante,dialog );
      })
      .catch(function() { estudiante.estado = null; });
      return;    
    },
    desmatricular2( estudiante,dialog ) {
      if( this.isLoading ) return;
      var vue = this;
      vue.isLoading = true;

      var cuerpo = {
        "data":{
          "attendant":{
            "name": this.asunto,
            "mail": this.correo
          },
          "unenrollment":{
            "username": estudiante.umoodle,
            "courseId": this.modulo.tag.course_id
          }
        }
      };
      var data = JSON.stringify(cuerpo);
      var url = process.env.VUE_APP_URL_NOTIFIER_ESAM+"unenrol-student-notification/";
      // window.console.log( "DATA> ",data,"ESTUDIANRES: ",this.estudiantes );

      var config = { method: 'post', url: url,headers: { 'Content-Type': 'application/json' }, data : data };
      window.axios(config)
        .then(function (res) {
          var data = res.data;
          // window.console.log('------------ RESPUESTA DEL SERVIDOR ------------')
          // window.console.log( ">> ",window.stringifyObject(data) )
          vue.isLoading = false;
          vue.msg = "";
          estudiante.estado = data.moodle+', '+data.mail;
          dialog.close();
        })
        .catch(function (error) {
          window.console.error(error)
          vue.isLoading = false;
          vue.msg = "";
          dialog.close();
      });
    },
    setEstudiantes(){
      // window.console.log( "KKKKKKKKKKKKKKKKKKKKKKKKKK" )
      this.datos = [];
      var dts = [];
      this.xprograma.inscripciones.forEach( function(e){
        var nom = e.estudiante.nombres+' '+e.estudiante.pri_apellido;
        if( e.estudiante.seg_apellido ) nom += ' '+e.estudiante.seg_apellido;
        dts.push( {id:e.estudiante.id,nombre:nom,umoodle:e.estudiante.usuario_moodle,estado:null,check:false} );
      })
      this.datos = dts;

      if( !this.xprograma.sede.correos ){
        this.activo = false;
        this.$refs.ealertar.invalido("ERROR: la sede no tiene correo."); 
      }else{
        var cor = this.xprograma.sede.correos.find( x => x.tipo == 0 );
        // window.console.log( "MODALL ",cor ); 
        if( cor ) {
          this.correo = cor.direccion;
        }
        else{
          this.activo = false;
          this.$refs.ealertar.invalido("ERROR: la sede no tiene correo del tipo 0 (corporativo)."); 
        }
      }
    },

    myFunction1( filtro ) {
        filtro = filtro.toUpperCase();
        var table, tr, tdd,td, i,j, txtValue;
        table = document.getElementById("midatatabledel");
        tr = table.getElementsByTagName("tr");
        for (i = 0; i < tr.length; i++) {
          tdd = tr[i].getElementsByTagName("td");
          for(j = 1; j< tdd.length;j++) {
            td = tdd[j];
            if (td) {
              txtValue = td.textContent;
              if (txtValue.toUpperCase().indexOf(filtro) > -1) {
                tr[i].style.display = "";
                break;
              } else {
                tr[i].style.display = "none";
              }
            } 
          }
        }
      }
  },
  mounted(){
    var vue = this;
    window.$('#modal-modulo-eliminar').on('show.bs.modal', function () {
      vue.setEstudiantes();
    })
  }
}
</script>